import { NetworkLogo } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectAppLocale } from 'modules/App/store/selectors'
import { useAuthState } from 'modules/Auth/hooks/useAuthState'
import { Link } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { APP_PRODUCT } from 'constants/app-config'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { IS_APP_PRODUCT_ADSIMPLE } from 'utils/constants/product'

const SIZES = {
  getuniq: {
    full: {
      width: 106,
      height: 36,
    },
    compact: {
      width: 36,
      height: 36,
    },
  },
  adsimple: {
    full: {
      width: 115,
      height: 36,
    },
    compact: {
      width: 36,
      height: 36,
    },
  },
}

const LogoIcon = ({ size = null, type = null }) => {
  const breakpoint = useBreakpoint()

  return (
    <NetworkLogo
      name={APP_PRODUCT}
      color={
        !breakpoint.fb && IS_APP_PRODUCT_ADSIMPLE ? 'Interface-GU-Primary' : 'Interface-Eleven'
      }
      type={type || !breakpoint.fb ? 'unlinked' : 'component'}
      {...SIZES[APP_PRODUCT][size || (!breakpoint.fb ? 'compact' : 'full')]}
    />
  )
}

LogoIcon.propTypes = {
  size: PropTypes.string,
  type: PropTypes.oneOf(['component', 'unlinked', PropTypes.oneOf([null])]),
}

const Logo = ({ className, size, type = null }) => {
  const i18n = useSelector(selectAppLocale)
  const { isAuthenticated } = useAuthState()
  const pathGen = useGeneratePathI18n()

  return isAuthenticated ? (
    <Link
      className={className}
      to={pathGen(ROUTES.SERVICES)}
    >
      <LogoIcon
        size={size}
        type={type}
      />
    </Link>
  ) : (
    <a href={i18n === 'ru' ? '/' : pathGen(ROUTES.MAIN)}>
      <LogoIcon
        size={size}
        type={type}
      />
    </a>
  )
}

Logo.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['component', 'unlinked', PropTypes.oneOf([null])]),
  size: PropTypes.oneOf(['compact', 'full']),
}

export default Logo

export { LogoIcon }
